import React, {Component} from 'react';
import MainStore from '../stores/MainStore.js';
import * as Cart from '../libraries/Cart.js';

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "CHECKOUT"
    };
  };


  checkout = () =>{
    if( this.state.text==="CHECKING OUT" ) return;
    
    if( this.props.total>0 ){
      if( !MainStore.has_discount_item || Cart.hasCustomDiscountItem() ){
        //window.location.href = "/checkout";
        Cart.customInvoice();
        this.setState({text:"CHECKING OUT"});
      }
      else{
        Cart.customInvoice();
        this.setState({text:"CHECKING OUT"});
      }
    }
  };

  render() {
    if( this.props.total<=0 ) return null;
    return (
      <button type="button" className={"btn btn-brown btn-checkout mx-auto "+(this.props?.className??"")} name="checkout_react" onClick={()=>this.checkout()}>
        <div className="animate__animated animate__heartBeat animate__repeat-3">
        {this.state.text}
        </div>
      </button>
    )
  };
}
export default Checkout;